<form [formGroup]="form" (ngSubmit)="onSubmitForm($event)">
  <div class="form-group pt-2" formGroupName="sourceName">
    <label for="sourceName">{{ 'Settings::NiceIntegrationSourceName' | abpLocalization }}</label>
    <input
      type="text"
      class="form-control form-control-sm"
      id="sourceName"
      formControlName="value" />
  </div>
  <div class="form-group pt-2" formGroupName="groupId">
    <label for="groupId">{{ 'Settings::NiceIntegrationGroupId' | abpLocalization }}</label>
    <input type="text" class="form-control form-control-sm" id="groupId" formControlName="value" />
  </div>
  <div class="form-group pt-2" formGroupName="clientId">
    <label for="clientId">{{ 'Settings::NiceIntegrationClientId' | abpLocalization }}</label>
    <input type="text" class="form-control form-control-sm" id="clientId" formControlName="value" />
  </div>
  <div class="form-group pt-2" formGroupName="clientSecret">
    <label for="clientSecret">
      {{ 'Settings::NiceIntegrationClientSecret' | abpLocalization }}
    </label>
    <input
      type="text"
      class="form-control form-control-sm"
      id="clientSecret"
      formControlName="value" />
  </div>
  <div class="form-group pt-2" formGroupName="accessKey">
    <label for="accessKey">{{ 'Settings::NiceIntegrationAccessKey' | abpLocalization }}</label>
    <input
      type="text"
      class="form-control form-control-sm"
      id="accessKey"
      formControlName="value" />
  </div>
  <div class="form-group pt-2" formGroupName="accessSecret">
    <label for="accessSecret">
      {{ 'Settings::NiceIntegrationAccessSecret' | abpLocalization }}
    </label>
    <input
      type="text"
      class="form-control form-control-sm"
      id="accessSecret"
      formControlName="value" />
  </div>
  <div class="form-group pt-2" formGroupName="useMultilingual">
    <input
      type="checkbox"
      id="useMultilingual"
      (change)="onUseMultilingualChange($event.currentTarget.checked)"
      [(ngModel)]="useMultilingualCb"
      formControlName="value" />
    <label class="ps-1" for="useMultilingual">
      {{ 'Settings::NiceIntegrationUseMultilingual' | abpLocalization }}
    </label>
  </div>
  <div
    class="form-group pt-2"
    *ngIf="form.get('useMultilingual').value"
    formGroupName="languageParameter">
    <label for="languageParameter">
      {{ 'Settings::NiceIntegrationLanguageParameter' | abpLocalization }}
    </label>
    <ca-select formControlName="value">
      <ca-option value="skillName">Skill Name</ca-option>
    </ca-select>
  </div>
  <div
    class="form-group pt-2"
    formGroupName="languageDictionary"
    *ngIf="form.get('useMultilingual.value').value">
    <label for="languageDictionary">
      {{ 'Settings::NiceIntegrationLanguageDictionary' | abpLocalization }}
    </label>
    <input
      type="text"
      class="form-control form-control-sm"
      id="languageDictionary"
      placeholder='{"Queue1Key":"languageCode","Queue2Key":"languageCode"}'
      formControlName="value" />
  </div>
<div class="form-group pt-2" formGroupName="minimumCallDuration">
  <label for="minimumCallDuration">{{ 'Settings::NiceIntegrationMinimumCallDuration' | abpLocalization }}</label>
  <p class="text-muted small mb-2">Calls shorter than this duration will be excluded from processing, transcription, and automatic evaluation.</p>
  <div class="position-relative">
    <input
      type="number"
      class="form-control form-control-sm"
      style="padding-right: 45px;" 
      id="minimumCallDuration"
      formControlName="value"
      min="0"
      max="3600"
      [ngClass]="{ 'is-invalid': isDurationInvalid }"
      (blur)="onBlurDuration()" />
      
    <span class="position-absolute text-muted" style="right: 25px; top: 50%; transform: translateY(-50%); pointer-events: none; font-size: 0.875rem;">
      sec
    </span>
  </div>
  <div class="invalid-feedback d-block" *ngIf="isDurationInvalid">
    <span class="text-danger">
      <i class="fa fa-exclamation-circle"></i> Please enter a value between 0 and 3600.
    </span>
  </div>
</div>
  <div class="form-group pt-2" formGroupName="migrationStartDate">
    <label for="migrationStartDate">
      {{ 'Settings::NiceIntegrationMigrationStartDate' | abpLocalization }}
    </label>
    <input
      type="text"
      placeholder="2023-01-31"
      class="form-control form-control-sm"
      id="migrationStartDate"
      formControlName="value" />
  </div>
  <button type="button" type="submit" class="btn btn-primary mt-3" [disabled]="!form.valid">
    <i class="me-1 fas fa-save"></i>
    {{ 'AbpUi::Save' | abpLocalization }}
  </button>
</form>
